import styled from 'styled-components'
import Select, { ActionMeta } from 'react-select'
import { useEffect, useState } from 'react'

import { useIsMobile } from 'utils/useIsMobile'

const StyledSelect = styled(Select)`
  .react-select__option--is-selected {
    color: ${p => p.theme.colors.text.primary} !important;
  }

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    width: 100%;
  }

  .react-select__control {
    // height: 40px;
    // min-height: 40px;
    border-radius: 100px;
    padding: 4px 12px;
    background: transparent;
    border: 1px solid ${p => p.theme.colors.text.primary};
    color: ${p => p.theme.colors.text.primary};
    cursor: pointer;
    &:hover {
      border: 1px solid ${p => p.theme.colors.text.primary};
    }
    &: active {
      border: 1px solid ${p => p.theme.colors.text.primary};
    }
    font-size: ${p => p.theme.typography.size.Description}px;

    @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
      height: 36px;
      min-height: 36px;
      font-size: ${p => p.theme.typography.size.Caption1}px;
    }

    @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
      min-width: 120px;
    }
  }

  .react-select__dropdown-indicator {
    color: ${p => p.theme.colors.text.primary};
    &:hover {
      color: ${p => p.theme.colors.text.primary};
    }
  }

  .react-select__option--is-focused {
    background-color: ${p => p.theme.colors.background.hover};
  }

  .react-select__option--is-selected {
    background-color: ${p => p.theme.colors.background.hover};
  }

  .react-select__single-value {
    color: ${p => p.theme.colors.text.primary};
  }

  .react-select__menu {
    background: transparent;
    color: ${p => p.theme.colors.text.primary} !important;
  }

  .react-select__option {
    cursor: pointer;
    color: ${p => p.theme.colors.text.primary} !important;
    font-size: ${({ theme }) => theme.typography.size.Description}px;
    @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
      font-size: ${p => p.theme.typography.size.Caption1}px;
    }
  }

  .react-select__control--is-focused {
    box-shadow: none !important;
    border-color: ${p => p.theme.colors.text.primary} !important;
  }

  .react-select__menu {
    background-color: ${p => p.theme.colors.background.primary};
  }

  .react-select__menu,
  .react-select__option {
    -webkit-tap-highlight-color: transparent;
    user-select: none;
  }

  /* active (mouse down) states → transparent */
  .react-select__option:active,
  .react-select__option--is-focused:active,
  .react-select__option--is-selected:active {
    background: ${({ theme }) => theme.colors.background.hover};
  }

  .react-select__value-container {
    height: 100%;
    padding: 0 6px;
    display: flex;
    align-items: center;
  }

  .react-select__input-container {
    margin: 0;
    padding: 0;
  }

  .react-select__indicators {
    height: 100%;
  }
`

export type Option = { value: string; label: string }

interface Props {
  options: Option[]
  selectedOption: Option
  onSelect: (option: Option) => void
}
export const ReactSelect = ({ options, selectedOption, onSelect }: Props) => {
  const isMobile = useIsMobile()

  const [selected, setSelected] = useState<Option>(selectedOption)

  useEffect(() => {
    setSelected(selectedOption)
  }, [selectedOption])

  const handleSelectChange = (newValue: unknown, _action: ActionMeta<unknown>) => {
    if (newValue) {
      setSelected(newValue as Option)
      onSelect(newValue as Option)
    }
  }

  return (
    <StyledSelect
      classNamePrefix="react-select"
      value={selected}
      onChange={handleSelectChange}
      options={options}
      isSearchable={false}
      components={{
        IndicatorSeparator: () => null,
      }}
      styles={
        isMobile
          ? {
              menuList: (base: any) => ({
                ...base,
                maxHeight: 150,
                overflowY: 'auto',
              }),
            }
          : {}
      }
    />
  )
}
